import { render, staticRenderFns } from "./CommentIG.vue?vue&type=template&id=548655f7&"
import script from "./CommentIG.vue?vue&type=script&lang=js&"
export * from "./CommentIG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports